function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22 7.6V11.8667H2V7.6C2 7.06667 2.2 6.63333 2.63333 6.26667C2.96666 5.96667 3.36666 5.83333 3.8 5.83333H7.7V4.13334C7.7 3.83334 7.8 3.5 8.03334 3.3C8.23334 3.1 8.5 3 8.76666 3H15.1C15.4 3 15.7333 3.09999 15.9333 3.33333C16.1333 3.53333 16.2333 3.8 16.2333 4.06667V5.86666H20.1667C20.6667 5.86666 21.0667 6.03333 21.4333 6.4C21.8 6.7 22 7.13333 22 7.6ZM22 12.9667V18.3333C22 18.8333 21.8333 19.2333 21.4667 19.6C21.1333 19.9333 20.7 20.1333 20.2 20.1333H3.8C3.3 20.1333 2.9 19.9667 2.53334 19.6C2.2 19.2667 2 18.8333 2 18.3333V12.9667H9.5V14.7667C9.5 14.9667 9.56667 15.1333 9.7 15.2667C9.83334 15.4 10 15.4667 10.2 15.4667H13.7667C13.9667 15.4667 14.1333 15.4 14.2667 15.2667C14.4 15.1333 14.4667 14.9667 14.4667 14.7667V12.9667H22ZM9.13333 5.83333H14.8333V5.33333C14.8333 4.83333 14.4333 4.4 13.9 4.4H10.0333C9.53334 4.4 9.1 4.79999 9.1 5.33333L9.13333 5.83333ZM13.4333 12.9667V14.4H10.5667V12.9667H13.4333Z",
  fill: "current"
});

var SvgComponent = function SvgComponent(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 24,
      height: 24,
      viewBox: "0 0 24 24"
    }, props), _ref)
  );
};

export default __webpack_public_path__ + "static/media/luggage-xs.2a5b5986.svg";
export { SvgComponent as ReactComponent };